import React from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'
import defaultThumbnailURL from '../images/videothumb-default.svg';

// STYLE ##########################################################

const sv = StyleVariales;

const Thumbnail = styled(`div`)`
  ${sv.flexCenter}
  max-width: ${props => props.maxWidth ? props.maxWidth + "px" : "auto"};
  max-height: ${props => props.maxHeight ? props.maxHeight : (props.maxWidth ? props.maxWidth*0.5625 : 202) }px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
  }
`;

// COMPONENT ##########################################################

const VideoThumbnail = ({ maxWidth, maxHeight, image, altText, time = false }) => {

  const imageURL = image || defaultThumbnailURL;
  const alternateText = altText || "gistify.ai";

  return (
    <Thumbnail
      className="Thumbnail"
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    >
      <img src={imageURL} alt={alternateText}/>
    </Thumbnail>
  )

};

export default VideoThumbnail
